import { Component } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import classNames from 'classnames/bind';

import { toggleExpandFilings } from '../../../../../actions/filingsFilters.actions';
import withComponentName from '../../../../../decorators/withComponentName';

import StorageSvc from '../../../../../services/StorageSvc';

import Styles from '../styles.module.scss';

const cx = classNames.bind(Styles);

class ExpandFilings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkStatus: false,
    };
    autoBind(this);
  }

  componentDidMount() {
    const { isExpandAll } = this.props;

    const rehydrate = JSON.parse(StorageSvc.getItem('expandFilings')) || {};

    if (typeof isExpandAll !== 'boolean') {
      this.setState({
        checkStatus: rehydrate.filingCardsExpanded || false,
      });
    } else {
      this.setState({
        checkStatus: isExpandAll,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { isExpandAll } = this.props;
    if (isExpandAll !== prevProps.isExpandAll) {
      this.setState({
        checkStatus: isExpandAll || false,
      });
    }
  }

  toggleCheck() {
    const { checkStatus } = this.state;
    const { piwikEnabled } = this.props;
    this.setState({
      checkStatus: !checkStatus,
    }, () => {
      const { checkStatus: status } = this.state;
      const { toggleExpandFilings: propsToggleExpandFilings, token } = this.props;
      if (piwikEnabled) {
        _paq.push(['trackEvent', 'Filings expand filters', `Status ${toggleExpandFilings}`]);
      }
      propsToggleExpandFilings(status, token);
      // save to localstorage for guest user
      if (!token) {
        StorageSvc.setItem(
          'expandFilings',
          JSON.stringify({ filingCardsExpanded: status }),
        );
      }
    });
  }

  render() {
    const { checkStatus } = this.state;

    return (
      <div className={cx('filings-filter-btn', 'expand_filings')}>
        <span className={Styles.expand_filings_label}>Expand Filings</span>
        <div className={Styles.switch_button}>
          <input
            type="checkbox"
            checked={checkStatus}
            onChange={this.toggleCheck}
          />
          <div className={Styles.toggle}>
            <label onClick={this.toggleCheck}>
              <i />
            </label>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  token: state.watchlistReducer.userToken,
  isExpandAll: state.storyFilters.expand_filings,
});

const mapToDispatchProps = {
  toggleExpandFilings,
};

export default withComponentName(
  connect(mapStateToProps, mapToDispatchProps)(ExpandFilings),
);
